import "core-js/stable";
import "regenerator-runtime/runtime";
import "element-closest-polyfill";
import "intersection-observer";
import "matchmedia-polyfill";
import "matchmedia-polyfill/matchMedia.addListener";
import "proxy-polyfill";
import "whatwg-fetch";
import "url-polyfill";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { HashRouter as Router } from "react-router-dom";
import App from "./app/App";
import "@fortawesome/fontawesome-free/js/all.min.js";
import "./index.scss";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import { ldProviderConfig } from "./helpers/launchDarklyHelpers";
import { getLdFlags } from "./api";
import { logError } from "./helpers";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.FontAwesome.config.autoReplaceSvg = "nest";

/** @ignore import registerServiceWorker from "./registerServiceWorker"; */

(async () => {
  const config = ldProviderConfig;

  try {
    const bootstrapFlags = await getLdFlags();

    if (bootstrapFlags) {
      const { flags } = bootstrapFlags;

      config.options.bootstrap = flags;
    }
  } catch (e) {
    logError("Unable to retrieve LD bootstrap flags", e);
  } finally {
    const LDProvider = await asyncWithLDProvider(config);

    ReactDOM.render(
      <LDProvider>
        <Router>
          <App />
        </Router>
      </LDProvider>,
      document.getElementById("mpf-root") as HTMLElement
    );
  }
})();
/* @ignore registerServiceWorker();

// Unregister Service Workers, if present
navigator.serviceWorker.getRegistrations().then(registrations => {
  for (const registration of registrations) {
    registration.unregister();
  }
}); */
